import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "app/components/components.module";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from '@angular/material/button';
import { NgModule } from "@angular/core";
import { MatCardModule } from '@angular/material/card';
import { ClienteFormComponent } from "./formularios-crud/cliente-form/cliente-form.component";
import { ProdutoFormComponent } from './formularios-crud/produto-form/produto-form.component';
import { DepartamentoFormComponent } from './formularios-crud/departamento-form/departamento-form.component';
import { MarcaFormComponent } from './formularios-crud/marca-form/marca-form.component';
import { LoadingComponent } from 'app/shared/loading/loading.component';
import { ServicoFormComponent } from './formularios-crud/servico-form/servico-form.component';
import { ClinicaFormComponent } from './formularios-crud/clinica-form/clinica-form.component';
import { AtendimentoFormComponent } from './formularios-crud/atendimento-form/atendimento-form.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxCurrencyDirective } from 'ngx-currency';
import { RecebimentoFinanceiroComponent } from './recebimento-financeiro-modal/recebimento-financeiro-modal.component';
import { AlterarSenhaModalComponent } from './alterar-senha-modal/alterar-senha-modal.component';
import { LembreteFormComponent } from './formularios-crud/lembrete-form/lembrete-form.component';
import { BloqueioAgendaFormComponent } from './formularios-crud/bloqueio-agenda-form/bloqueio-agenda-form.component';
import { EvolucaoFormComponent } from './formularios-crud/evolucao-form/evolucao-form.component';
import { FormularioBuilderComponent } from './formularios-crud/formulario-builder/formulario-builder.component';
import { FormularioPreenchimentoComponent } from './formularios-crud/formulario-preenchimento/formulario-preenchimento.component';
import { DocumentoUploadComponent } from './formularios-crud/documento-upload/documento-upload.component';
import { DespesaFormModalComponent } from './despesa-form-modal/despesa-form-modal.component';
import { GastoPessoalFormModalComponent } from './gasto-pessoal-form-modal/gasto-pessoal-form-modal.component';
import { BoasVindasModalComponent } from './boas-vindas-modal/boas-vindas-modal.component';
import { AcompanhamentoModalComponent } from './acompanhamento-modal/acompanhamento-modal.component';
import { QuillEditorComponent } from 'ngx-quill';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AudioRecorderComponent } from 'app/shared/audio/audio-recorder.component';
import { AudioPlayerComponent } from 'app/shared/audio/audio-player.component';

@NgModule({
  declarations: [
    ProdutoFormComponent,
    MarcaFormComponent,
    DepartamentoFormComponent,
    ClienteFormComponent,
    ServicoFormComponent,
    ClinicaFormComponent,
    AtendimentoFormComponent,
    RecebimentoFinanceiroComponent,
    AlterarSenhaModalComponent,
    LembreteFormComponent,
    BloqueioAgendaFormComponent,
    EvolucaoFormComponent,
    FormularioBuilderComponent,
    FormularioPreenchimentoComponent,
    DocumentoUploadComponent,
    DespesaFormModalComponent,
    GastoPessoalFormModalComponent,
    BoasVindasModalComponent,
    AcompanhamentoModalComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    NgbPaginationModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    NgxMaskDirective,
    MatCardModule,
    LoadingComponent,
    NgxCurrencyDirective,
    QuillEditorComponent,
    DragDropModule,
    MatDatepickerModule,
    AudioRecorderComponent,
    AudioPlayerComponent,
  ],
  providers: [provideNgxMask()],
  exports: [
  ],
})

export class ModalsModule { }
